export * from './WindowProvider';

import './version';
